import React from 'react'
import { useNavigate } from 'react-router-dom'
import type { Session, Team, Step } from '../../types'
import styles from './TeamHeader.module.css'

export interface TeamHeaderProps {
  session: Session
  team: Team
  steps: Step[]
  className?: string
}

export function TeamHeader({ session, team, steps, className }: TeamHeaderProps) {
  const navigate = useNavigate()
  const stepsTotal = steps.length
  const stepsDone = steps.filter((s) => s.status === 'done' || s.status === 'skipped').length
  const allDone = stepsTotal > 0 && stepsDone === stepsTotal

  return (
    <header
      className={`${styles.header} ${className || ''}`}
      data-testid="team-header"
    >
      <button
        className={styles.backBtn}
        onClick={() => navigate(`/war-room/${session.id}`)}
        aria-label="Back to Dashboard"
      >
        ← Back to Dashboard
      </button>

      <div className={styles.teamInfo}>
        <span className={styles.teamIcon}>{team.icon}</span>
        <span className={styles.teamName}>{team.name}</span>
        <span className={styles.teamType}>{team.team_type}</span>
      </div>

      <div className={`${styles.progress} ${allDone ? styles.progressDone : ''}`}>
        {stepsDone}/{stepsTotal} steps
      </div>
    </header>
  )
}
